import firebaseModules from "./Firebase";
import * as DataService from "./DataService";

const auth = firebaseModules.auth;

export const loginUser = async (email, password) => {
  const request = await auth.signInWithEmailAndPassword(email, password);
  const data = await DataService.fetchCollectionById("users", email);
  return { ...data, uid: request.user.uid, projects: "" };
};
